(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-media-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.flip-slider-section');
  if (!section) return;

  const wrapper = section.querySelector('.flip-slider-wrapper');
  const heading = section.querySelector('.main-heading');
  const sliderStage = section.querySelector('.slider-stage');
  const slides = section.querySelectorAll('.slide-item');
  const dotsContainer = section.querySelector('.slider-dots');
  const dots = section.querySelectorAll('.dot');
  const slideCount = slides.length;

  function updateSlides(newIndex) {
    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (video) video.pause();
      slide.classList.remove('is-active', 'was-active');
      if (index === newIndex) {
        slide.classList.add('is-active');
        if (video) video.play().catch(() => {});
      } else if (index < newIndex) {
        slide.classList.add('was-active');
      }
    });
    dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === newIndex);
    });
  }

  function handleScroll() {
    const rect = wrapper.getBoundingClientRect();
    const scrollY = -rect.top;
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;

    const introH = window.innerHeight;
    const introP = Math.min(1, scrollY / introH);

    const scale = 1 - (0.7 * introP);
    const translateY = -22 * introP;
    const stageTY = -50 + (18 * introP);
    const contentOp = introP > 0.5 ? (introP - 0.5) * 2 : 0;

    requestAnimationFrame(() => {
      if (heading) heading.style.transform = `translateY(${translateY}vh) scale(${scale})`;
      if (sliderStage) {
        sliderStage.style.transform = `translate(-50%, ${stageTY}%)`;
        sliderStage.style.opacity = contentOp;
      }
      if (dotsContainer) dotsContainer.style.opacity = contentOp;
    });

    if (scrollY >= introH) {
      const slideProg = Math.min(1, (scrollY - introH) / (wrapper.clientHeight - introH - window.innerHeight));
      updateSlides(Math.floor(slideProg * slideCount));
    } else {
      updateSlides(0);
    }
  }

  updateSlides(0);
  window.addEventListener('scroll', handleScroll, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-finder-PC-SP"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  function initSF() {
    if (typeof window.SFCore === 'undefined') {
      setTimeout(initSF, 50);
      return;
    }
    var SF = window.SFCore;
    var productMapping = SF.getProductMapping();

    document.querySelectorAll('.sizeGuide__result, .custom-sf-result').forEach(function(el) {
      el.style.display = 'none';
    });

    /* --- PC用 --- */
    function showResult(size, linkSelector, sizeTextSelector) {
      var sizeText = document.querySelector(sizeTextSelector);
      if (sizeText) sizeText.textContent = size;
      var link = SF.getShopLink(size, productMapping);
      var linkEl = document.querySelector(linkSelector);
      if (!linkEl) return;
      if (link.indexOf('PRODUCT:') === 0) {
        linkEl.textContent = 'スーパー TYPEⅡを見る';
        linkEl.href = link.slice(8);
      } else if (link === 'LINEUP') {
        linkEl.textContent = '商品一覧を見る';
        linkEl.href = 'https://issechains.jp/collections/line-up';
      } else {
        linkEl.textContent = 'カートに追加';
        linkEl.href = link;
      }
    }

    var tireSearch = document.getElementById('tire_search');
    if (tireSearch) {
      tireSearch.addEventListener('click', function(e) {
        e.preventDefault();
        ['tire_width','tire_border','tire_rim'].forEach(function(id) {
          var el = document.getElementById(id);
          if (el && SF.hasFull(el.value)) el.value = SF.toHalf(el.value);
        });
        var w = parseFloat(document.getElementById('tire_width').value);
        var b = parseFloat(document.getElementById('tire_border').value);
        var r = parseFloat(document.getElementById('tire_rim').value);
        if (isNaN(w) || isNaN(b) || isNaN(r)) {
          alert('タイヤ幅、偏平率、インチを正しく入力してください');
          return;
        }
        showResult(SF.judgeSize(SF.calcPerimeter(w, b, r)), '.sizeGuide__result__link__buylink', '#sizeResult');
        var resultEl = document.querySelector('.sizeGuide__result');
        if (resultEl) {
          resultEl.style.display = '';
          resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }

    var tireSpecial = document.getElementById('tire_special');
    if (tireSpecial) {
      tireSpecial.addEventListener('change', function() {
        ['tire_width','tire_border','tire_rim'].forEach(function(id) {
          var el = document.getElementById(id);
          if (el) el.value = '';
        });
        showResult(SF.judgeSpecialSize(tireSpecial.value), '.sizeGuide__result__link__buylink', '#sizeResult');
        var resultEl = document.querySelector('.sizeGuide__result');
        if (resultEl) resultEl.style.display = '';
      });
    }

    /* --- SP用 --- */
    function render(size) {
      document.querySelectorAll('.size-main').forEach(function(el) { el.textContent = size; });
      document.querySelectorAll('.custom-sf-result .sizeResult').forEach(function(el) { el.textContent = size; });
      var link = SF.getShopLink(size, productMapping);
      document.querySelectorAll('.custom-sf-result-link-buylink').forEach(function(btn) {
        if (!btn) return;
        if (link.indexOf('PRODUCT:') === 0) {
          btn.textContent = 'スーパー TYPEⅡを見る';
          btn.href = link.slice(8);
        } else if (link === 'LINEUP') {
          btn.textContent = '商品一覧を見る';
          btn.href = 'https://issechains.jp/collections/line-up';
        } else {
          btn.textContent = 'カートに追加';
          btn.href = link;
        }
      });
      document.querySelectorAll('.custom-sf-result').forEach(function(el) { el.style.display = ''; });
    }

    document.querySelectorAll('.custom-sf-btn .custom-sf-search').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var form = btn.closest('.custom-sf-form');
        var wEl = form.querySelector('.custom-sf-tire_width');
        var bEl = form.querySelector('.custom-sf-tire_border');
        var rEl = form.querySelector('.custom-sf-tire_rim');
        [wEl, bEl, rEl].forEach(function(el) {
          if (SF.hasFull(el.value)) el.value = SF.toHalf(el.value);
        });
        var width  = parseFloat(wEl.value || wEl.placeholder);
        var border = parseFloat(bEl.value || bEl.placeholder);
        var rim    = parseFloat(rEl.value || rEl.placeholder);
        if ([width, border, rim].some(isNaN)) {
          alert('タイヤ幅、偏平率、インチを正しく入力してください');
          return;
        }
        render(SF.judgeSize(SF.calcPerimeter(width, border, rim)));
      });
    });

    document.querySelectorAll('.custom-sf-tire_special').forEach(function(sel) {
      sel.addEventListener('change', function() {
        document.querySelectorAll('.custom-sf-tire_width, .custom-sf-tire_border, .custom-sf-tire_rim').forEach(function(el) {
          el.value = '';
        });
        render(SF.judgeSpecialSize(sel.value));
      });
    });

    document.addEventListener('click', function(e) {
      var linkBtn = e.target.closest('.custom-sf-result-link-buylink');
      if (!linkBtn) return;
      var href = linkBtn.href;
      if (!href || href === '#' || href.endsWith('#')) {
        e.preventDefault();
        alert('対応する商品が見つかりませんでした。商品一覧をご覧ください。');
        return;
      }
      if (href.includes('/collections/line-up')) return;
      e.preventDefault();
      SF.addToCart(href.split('/cart/')[1].split(':')[0])
        .then(function() { location.href = '/cart'; })
        .catch(function() { alert('カートに追加できませんでした。もう一度お試しください。'); });
    });
  }
  initSF();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-finder-merged"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  function initSF() {
    if (typeof window.SFCore === 'undefined') {
      setTimeout(initSF, 50);
      return;
    }
    var SF = window.SFCore;
    var productMapping = SF.getProductMapping();

    document.querySelectorAll('.custom-sf-result').forEach(function(el) {
      el.style.display = 'none';
    });

    function render(size, form) {
      var sizeMain = form.closest('.custom-sf-inner').querySelector('.size-main');
      if (sizeMain) sizeMain.textContent = size;
      var resultArea = form.querySelector('.custom-sf-result');
      resultArea.querySelector('.sizeResult').textContent = size;
      var link = SF.getShopLink(size, productMapping);
      var btn = resultArea.querySelector('.custom-sf-result-link-buylink');
      if (btn) {
        if (link.indexOf('PRODUCT:') === 0) {
          btn.textContent = 'スーパー TYPEⅡを見る';
          btn.href = link.slice(8);
        } else if (link === 'LINEUP') {
          btn.textContent = '商品一覧を見る';
          btn.href = 'https://issechains.jp/collections/line-up';
        } else {
          btn.textContent = 'カートに追加';
          btn.href = link;
        }
      }
      resultArea.style.display = '';
    }

    document.querySelectorAll('.custom-sf-btn .custom-sf-search').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var form = btn.closest('.custom-sf-form');
        var wEl = form.querySelector('.custom-sf-tire_width');
        var bEl = form.querySelector('.custom-sf-tire_border');
        var rEl = form.querySelector('.custom-sf-tire_rim');
        [wEl, bEl, rEl].forEach(function(el) {
          if (SF.hasFull(el.value)) el.value = SF.toHalf(el.value);
        });
        var width  = parseFloat(wEl.value || wEl.placeholder);
        var border = parseFloat(bEl.value || bEl.placeholder);
        var rim    = parseFloat(rEl.value || rEl.placeholder);
        if ([width, border, rim].some(isNaN)) {
          alert('タイヤ幅、偏平率、インチを正しく入力してください');
          return;
        }
        render(SF.judgeSize(SF.calcPerimeter(width, border, rim)), form);
      });
    });

    document.querySelectorAll('.custom-sf-tire_special').forEach(function(sel) {
      sel.addEventListener('change', function() {
        var form = sel.closest('.custom-sf-form');
        form.querySelectorAll('.custom-sf-tire_width, .custom-sf-tire_border, .custom-sf-tire_rim').forEach(function(el) {
          el.value = '';
        });
        render(SF.judgeSpecialSize(sel.value), form);
      });
    });

    document.addEventListener('click', function(e) {
      var linkBtn = e.target.closest('.custom-sf-result-link-buylink');
      if (!linkBtn) return;
      var href = linkBtn.href;
      if (!href || href === '#' || href.endsWith('#')) {
        e.preventDefault();
        alert('対応する商品が見つかりませんでした。商品一覧をご覧ください。');
        return;
      }
      if (href.includes('/collections/line-up')) return;
      e.preventDefault();
      SF.addToCart(href.split('/cart/')[1].split(':')[0])
        .then(function() { location.href = '/cart'; })
        .catch(function() { alert('カートに追加できませんでした。もう一度お試しください。'); });
    });
  }
  initSF();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-finder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // sp-float-bottom バウンスアニメーション
  setTimeout(function() {
    var sizeBar = document.querySelector(".sp-float-bottom");
    if (sizeBar) sizeBar.style.animation = "hop 0.6s ease-in-out 3";
  }, 1000);
  var style = document.createElement("style");
  style.innerHTML = "@keyframes hop{0%{transform:translateY(0)}30%{transform:translateY(-10px)}60%,100%{transform:translateY(0)}}.sp-float-bottom{animation:none}";
  document.head.appendChild(style);

  function initSF() {
    if (typeof jQuery === 'undefined' || typeof window.SFCore === 'undefined') {
      setTimeout(initSF, 50);
      return;
    }
    var SF = window.SFCore;
    var productMapping = SF.getProductMapping();

    $(".sizeGuide__result").hide();
    $(".footer__sizeGuide__result").hide();

    // モバイル用フッター表示切替
    var footerGuideJa = document.querySelector('.footer__sizeGuide__ja');
    if (footerGuideJa) {
      footerGuideJa.addEventListener('click', function() {
        var finder = document.querySelector('.sp-size-finder-visible-wrap');
        if (finder.style.display === 'none' || finder.style.display === '') {
          finder.style.display = 'block';
          setTimeout(function() { finder.scrollIntoView({ behavior: 'smooth', block: 'end' }); }, 100);
        } else {
          finder.style.display = 'none';
        }
      });
    }
    var closeBtn = document.querySelector('.footer_finder_close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        document.querySelector('.sp-size-finder-visible-wrap').style.display = 'none';
      });
    }

    function showResult(size, linkSelector, sizeTextSelector) {
      $(sizeTextSelector).text(size);
      var link = SF.getShopLink(size, productMapping);
      if (link.indexOf("PRODUCT:") === 0) {
        $(linkSelector).text("スーパー TYPEⅡを見る").attr("href", link.slice(8));
      } else if (link === "LINEUP") {
        $(linkSelector).text("商品一覧を見る").attr("href", "https://issechains.jp/collections/line-up");
      } else {
        $(linkSelector).text("カートに追加").attr("href", link);
      }
    }

    function bindDesktopSearch() {
      $(document).off("click", "#tire_search").on("click", "#tire_search", function(e) {
        e.preventDefault();
        ["#tire_width","#tire_border","#tire_rim"].forEach(function(sel) {
          if (SF.hasFull($(sel).val())) $(sel).val(SF.toHalf($(sel).val()));
        });
        var w = parseFloat($("#tire_width").val());
        var b = parseFloat($("#tire_border").val());
        var r = parseFloat($("#tire_rim").val());
        if (isNaN(w) || isNaN(b) || isNaN(r)) {
          alert("タイヤ幅、偏平率、インチを正しく入力してください");
          return;
        }
        showResult(SF.judgeSize(SF.calcPerimeter(w, b, r)), ".sizeGuide__result__link__buylink", "#sizeResult");
        $(".sizeGuide__result").slideDown();
        gsap.to(".sizeGuide__inner", { duration: 2, scrollTo: $(".sizeGuide__result").offset().top });
      });
    }

    function bindFooterSearch() {
      $(document).off("click", "#footer_tire_search").on("click", "#footer_tire_search", function(e) {
        e.preventDefault();
        ["#footer_tire_width","#footer_tire_border","#footer_tire_rim"].forEach(function(sel) {
          if (SF.hasFull($(sel).val())) $(sel).val(SF.toHalf($(sel).val()));
        });
        var w = parseFloat($("#footer_tire_width").val());
        var b = parseFloat($("#footer_tire_border").val());
        var r = parseFloat($("#footer_tire_rim").val());
        if (isNaN(w) || isNaN(b) || isNaN(r)) {
          alert("タイヤ幅、偏平率、インチを正しく入力してください");
          return;
        }
        showResult(SF.judgeSize(SF.calcPerimeter(w, b, r)), ".footer__sizeGuide__result__link__buylink", "#footer_sizeResult");
        $(".footer__sizeGuide__result").slideDown();
        gsap.to(window, { duration: 2, scrollTo: $(".footer__sizeGuide__result").offset().top - 135 });
      });
    }

    $("#tire_special").off("change").on("change", function() {
      $("#tire_width, #tire_border, #tire_rim").val("");
      showResult(SF.judgeSpecialSize($(this).val()), ".sizeGuide__result__link__buylink", "#sizeResult");
      $(".sizeGuide__result").slideDown();
    });

    $("#footer_tire_special").off("change").on("change", function() {
      $("#footer_tire_width, #footer_tire_border, #footer_tire_rim").val("");
      showResult(SF.judgeSpecialSize($(this).val()), ".footer__sizeGuide__result__link__buylink", "#footer_sizeResult");
      $(".footer__sizeGuide__result").slideDown();
      gsap.to(window, { duration: 2, scrollTo: $(".footer__sizeGuide__result").offset().top - 135 });
    });

    bindDesktopSearch();
    bindFooterSearch();
    setInterval(bindFooterSearch, 1000);
  }
  initSF();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spain-size-finder-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function initSF() {
    if (typeof jQuery === 'undefined' || typeof window.SFCore === 'undefined') {
      setTimeout(initSF, 50);
      return;
    }
    var SF = window.SFCore;
    var productMapping = SF.getProductMapping();

    $(".custom-sf-result").hide();

    function render(size) {
      $(".size-main").text(size);
      $(".sizeResult").text(size);
      var link = SF.getShopLink(size, productMapping);
      var $btn = $(".custom-sf-result-link-buylink");
      if (link.indexOf("PRODUCT:") === 0) {
        $btn.text("スーパー TYPEⅡを見る").attr("href", link.slice(8));
      } else if (link === "LINEUP") {
        $btn.text("商品一覧を見る").attr("href", "https://issechains.jp/collections/line-up");
      } else {
        $btn.text("カートに追加").attr("href", link);
      }
      $(".custom-sf-result").slideDown();
    }

    $(".custom-sf-btn .custom-sf-search").on("click", function (e) {
      e.preventDefault();
      var $form = $(this).closest(".custom-sf-form");
      var $w = $form.find(".custom-sf-tire_width");
      var $b = $form.find(".custom-sf-tire_border");
      var $r = $form.find(".custom-sf-tire_rim");
      [$w, $b, $r].forEach(function($el) {
        if (SF.hasFull($el.val())) $el.val(SF.toHalf($el.val()));
      });
      var width  = parseFloat($w.val() || $w.attr("placeholder"));
      var border = parseFloat($b.val() || $b.attr("placeholder"));
      var rim    = parseFloat($r.val() || $r.attr("placeholder"));
      if ([width, border, rim].some(isNaN)) {
        alert("タイヤ幅、偏平率、インチを正しく入力してください");
        return;
      }
      render(SF.judgeSize(SF.calcPerimeter(width, border, rim)));
    });

    $(".custom-sf-tire_special").on("change", function () {
      $(".custom-sf-tire_width, .custom-sf-tire_border, .custom-sf-tire_rim").val("");
      render(SF.judgeSpecialSize($(this).val()));
    });

    $(document).on("click", ".custom-sf-result-link-buylink", function (e) {
      var href = this.href;
      if (!href || href === "#" || href.endsWith("#")) {
        e.preventDefault();
        alert("対応する商品が見つかりませんでした。商品一覧をご覧ください。");
        return;
      }
      if (href.includes("/collections/line-up")) return;
      e.preventDefault();
      SF.addToCart(href.split("/cart/")[1].split(":")[0])
        .then(function() { location.href = "/cart"; })
        .catch(function() { alert("カートに追加できませんでした。もう一度お試しください。"); });
    });
  }
  initSF();
});

  } catch(e) { console.error(e); }
})();
})();
